// extracted by mini-css-extract-plugin
module.exports = {"audios_container":"style_audios_container__u89EC","audios":"style_audios__1ojq0"};